export default "__VITE_ASSET__tBCVIqzn3p1lJ4T4Xm84Vw__"